import React from 'react';
import Modal from './common/Modal';
import ResumePreview from './ResumePreview';

const ResumePreviewModal = ({resumeDetails, ...props}) => {
  return (
    <Modal {...props} containerClassName="max-w-[800px]">
      <ResumePreview resumeDetails={resumeDetails} />
    </Modal>
  );
};

export default ResumePreviewModal;
